import React from 'react';
import { Column, NumberMenu, ColumnType, Table, TableProps } from '@spins/react-table';
import { Formats } from '@spins/react-ui-library';
import ColoredValue from '../ColoredValue';
import { isValueDefined } from 'utils/functions';

interface ItemsTableProps
  extends Pick<
    TableProps<any>,
    'error' | 'queryState' | 'rows' | 'totalRows' | 'showLoading' | 'onRowClick'
  > {}

const ItemsTable: React.FC<ItemsTableProps> = ({
  error,
  queryState,
  rows,
  showLoading,
  totalRows,
  onRowClick
}) => {
  const columns: Array<ColumnType<any>> = [
    {
      accessor: 'name',
      header: 'Item Description',
      width: 25,
      isDraggable: false
    },
    {
      accessor: 'upc',
      header: 'UPC',
      width: 15,
      isDraggable: false
    },
    {
      accessor: 'sales',
      cell: (value: number) => (isValueDefined(value) ? Formats.currency(value) : '-'),
      header: '$',
      width: 7,
      filter: {
        renderer: (column: Column<any>, onApply: any) => (
          <NumberMenu column={column} onApply={onApply} />
        ),
        props: { decimals: 0 }
      },
      isDraggable: false
    },
    {
      accessor: 'salesDelta',
      cell: (value: number) =>
        isValueDefined(value) ? (
          <ColoredValue type="percentage" value={value} showPositiveSign={true} decimals={1} />
        ) : (
          '-'
        ),
      header: '$ Chg YAGO',
      width: 7,
      filter: {
        renderer: (column: Column<any>, onApply: any) => (
          <NumberMenu column={column} onApply={onApply} />
        ),
        props: { decimals: 1 }
      },
      isDraggable: false
    },
    {
      accessor: 'units',
      cell: (value: number) => (isValueDefined(value) ? Formats.number(value) : '-'),
      header: 'Units',
      width: 7,
      filter: {
        renderer: (column: Column<any>, onApply: any) => (
          <NumberMenu column={column} onApply={onApply} />
        ),
        props: { decimals: 0 }
      },
      isDraggable: false
    },
    {
      accessor: 'unitsDelta',
      cell: (value: number) =>
        isValueDefined(value) ? (
          <ColoredValue type="percentage" value={value} showPositiveSign={true} decimals={1} />
        ) : (
          '-'
        ),
      header: 'Units Chg YAGO',
      width: 7,
      filter: {
        renderer: (column: Column<any>, onApply: any) => (
          <NumberMenu column={column} onApply={onApply} />
        ),
        props: { decimals: 1 }
      },
      isDraggable: false
    },
    {
      accessor: 'arp',
      cell: (value: number) =>
        isValueDefined(value) ? Formats.currency(value, { decimals: 2 }) : '-',
      header: 'ARP',
      width: 7,
      filter: {
        renderer: (column: Column<any>, onApply: any) => (
          <NumberMenu column={column} onApply={onApply} />
        ),
        props: { decimals: 2 }
      },
      isDraggable: false
    },
    {
      accessor: 'pod',
      cell: (value: number) => (isValueDefined(value) ? Formats.number(value) : '-'),
      header: 'POD',
      width: 7,
      filter: {
        renderer: (column: Column<any>, onApply: any) => (
          <NumberMenu column={column} onApply={onApply} />
        ),
        props: { decimals: 0 }
      },
      isDraggable: false
    },
    {
      accessor: 'podDelta',
      cell: (value: number) =>
        isValueDefined(value) ? (
          <ColoredValue type="percentage" value={value} showPositiveSign={true} decimals={1} />
        ) : (
          '-'
        ),
      header: 'POD Delta PREV',
      width: 7,
      filter: {
        renderer: (column: Column<any>, onApply: any) => (
          <NumberMenu column={column} onApply={onApply} />
        ),
        props: { decimals: 1 }
      },
      isDraggable: false
    },
    {
      accessor: 'unitsSsw',
      cell: (value: number) =>
        isValueDefined(value) ? Formats.number(value, { decimals: 2 }) : '-',
      header: 'Units / SS / Wk',
      width: 11,
      filter: {
        renderer: (column: Column<any>, onApply: any) => (
          <NumberMenu column={column} onApply={onApply} />
        ),
        props: { decimals: 2 }
      },
      isDraggable: false
    }
  ];
  return (
    <Table
      columns={columns}
      error={error}
      layoutFixed={true}
      queryState={queryState}
      showLoading={showLoading}
      rows={rows}
      totalRows={totalRows}
      onRowClick={onRowClick}
    />
  );
};

export default ItemsTable;
